module.exports = __webpack_public_path__ + "static/media/logo_coop.bd611d6d.png";